/**
 * Values of this enum are checked and used
 * if they exist as Root Attributes on the root div (as data-attributes)
 * e.g. data-hide_header="true"
 */
export enum RootAttribute {
  ApiUrl = "api_url",
  Languages = "languages",
  ExcludeDates = "exclude_dates",
  HideHeader = "hide_header",
  HideParcelVehiclePicker = "hide_parcel_vehicle_picker",
  ParcelVehiclePickerDimensionsMandatory = "parcel_vehicle_picker_dimensions_mandatory",
  GTM_ID = "gtm_id",
  ShowAdultAgePicker = "show_adult_age_picker",
  HideCategoryPicker = "hide_category_picker",
  DisableRateGroupContinue = "disable_rate_group_continue",
  UseClassicRatePlanDetails = "use_classic_rate_plan_details",
  // uses [accommodationType.code]
  AccommodationTypesForPayment = "accommodation_types_for_payment",
  // uses [rateGroup.code]
  RateGroupsForPayment = "rate_groups_for_payment",
  ShowCardLogos = "show_card_logos",
  // optional array of iso3Code strings to show first in country pickers
  PriorityCountries = "priority_countries",
  ScrollOffset = "scroll_offset",
}
